import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _map from 'lodash/map';
import _castArray from 'lodash/castArray';
import _camelCase from 'lodash/camelCase';
import PropTypes from 'prop-types';
// Custom
import { FormRefContext } from './Contexts';
import Callout from './Callout';
import ScrollerElement from './ScrollerElement';

const formatAdditionalError = (additionalError) => (
  <ul className="m-0 pl-2">
    {_map(_castArray(additionalError), (error) => (
      <li key={_camelCase(error)}>
        {error}
      </li>
    ))}
  </ul>
);

/* ========================================================= */
/* SUB COMPONENTS                                            */
/* ========================================================= */

const ErrorsDisplayerContent = ({ errors, formattedAdditionalError }) => {
  if (errors) {
    return (
      <div className="mb-3">
        <Callout severity="error" withInfoIcon>
          <LocalizedMessage id={`error.${errors.global}`} values={{ additionalError: formattedAdditionalError || '' }} />
        </Callout>
      </div>
    );
  }
  return null;
};

ErrorsDisplayerContent.propTypes = {
  errors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  formattedAdditionalError: PropTypes.node,
};

ErrorsDisplayerContent.defaultProps = {
  errors: null,
  formattedAdditionalError: null,
};

/* ========================================================= */
/* MAIN COMPONENT                                            */
/* ========================================================= */

const ErrorsDisplayer = ({ errors, additionalError, noFormRef }) => {
  let formattedAdditionalError;
  if (errors) {
    // Build additional errors
    formattedAdditionalError = additionalError ? formatAdditionalError(additionalError) : null;
  }

  if (noFormRef) {
    return (
      <ErrorsDisplayerContent errors={errors} formattedAdditionalError={formattedAdditionalError} />
    );
  }

  /* ========================================================= */
  /* UI                                                        */
  /* ========================================================= */
  return (
    <FormRefContext.Consumer>
      {(formRef) => (
        <ScrollerElement target="errorDisplayer" name={formRef}>
          <ErrorsDisplayerContent errors={errors} formattedAdditionalError={formattedAdditionalError} />
        </ScrollerElement>
      )}
    </FormRefContext.Consumer>
  );
};

ErrorsDisplayer.propTypes = {
  errors: PropTypes.shape({
    global: PropTypes.string.isRequired,
  }),
  additionalError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
  noFormRef: PropTypes.bool,
};

ErrorsDisplayer.defaultProps = {
  errors: null,
  additionalError: null,
  noFormRef: false,
};

module.exports = ErrorsDisplayer;



// WEBPACK FOOTER //
// ./components/misc/ErrorsDisplayer.js